import "./style";

const FontSetting = () => {
  return null;
};

export default FontSetting;
